import { defineMessages } from 'react-intl';

export default defineMessages({
  statusLevelBenefitsHeading: {
    id: 'rewards.statusLevelBenefits.heading',
    defaultMessage: 'Your {level} Status benefits',
    description: 'Heading for status level benefits section in rewards page',
  },
});
